import React, { Component } from 'react';
import logo from '../../assets/logo.svg';
import classes from './Loader.css';
import { Redirect } from 'react-router-dom';

class Loader extends Component {
    
  state = {
    isLoaded: false
  }

  componentDidMount() {
    setTimeout(this.loadGenerator, 3000);
  }

  loadGenerator = () => {
    this.setState({
      isLoaded: true
    })
  }

  render() {
    let redirect = null;
    
    if(this.state.isLoaded){
      redirect = <Redirect to="/generator" />;
    }
    return (
        <div className={classes.Loader} >
            {redirect}
            <div className={classes.LogoHolder}>
                <img src={logo} className={classes.Logo} alt="logo" />
            </div>
        </div>
    )
}
}

export default Loader;


// WEBPACK FOOTER //
// ./src/containers/Loader/Loader.js